import {ComponentConfigurationClass} from "@zoovu/runner-browser-api";
import {ConfigurationValues, ValuesConfigurationConstructor} from "./values";
import { Attribute } from "./attribute";

interface JavascriptConfiguration {
    code: string;
}

interface UrlConfiguration {
    /**
     * @title Link a product attribute
     */
    attribute?: Attribute;
}

interface ShowAddToCartButtonConfiguration {
    enabled: boolean;
    option?: string;
    url?: UrlConfiguration;
    javascript?: JavascriptConfiguration;
}

/**
 * @title Product Buttons
 * @additionalProperties false
 */
@ValuesConfigurationConstructor(ConfigurationValues.ProductButtonSettings)
@ComponentConfigurationClass("productButtonConfiguration")
export class ProductButtonConfiguration {
    /**
     *  @title Show "Product details" button
     *  @description If enabled, shows the button linked to the product details page (as defined in the Product Attributes ➞ Mandatory Attributes Mapping ➞ offerurl)
     */
    public showGoToProductButton?: boolean;

    /**
     *  @title Open product details in a new tab
     */
    public openProductLinkInNewTab?: boolean;

    /**
     * @title Show "Add to cart" button
     * @description If enabled, shows a button linked to the cart in the marketplace
     * @format custom-atc-buttons-configuration
     */
    public showAddToCartButton?: ShowAddToCartButtonConfiguration;

    /**
     * @title Show "Add all to cart" button
     * @description Shows a button used to add all the products in the bundle to the customer's cart
     * @format custom-aatc-buttons-configuration
     */
    public showAddAllToCartButton?: ShowAddToCartButtonConfiguration;
}
